export function graphQLResultHasError(result) {
    return (result.errors && result.errors.length > 0) || false;
}
//# sourceMappingURL=errorHandling.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/common/errorHandling.js
// module id = ./node_modules/@apollo/client/utilities/common/errorHandling.js
// module chunks = 54 55